import React from 'react'
import Box from '@material-ui/core/Box'
import EmptyStudents from 'components/empty-page-state'
import PermContactCalendarOutlinedIcon from 'components/material-symbol/icons/PermContactCalendar'
import EnhancedTable from 'components/tables/enhanced-table'
import { LeadTableItem } from './lead-table-item'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const NewLeads = ({
  awaitingResponseLeads,
  contactMethodOptions = [],
  setUnviewedLeadCount,
  refetch,
  sortByFullName,
  sortByCreatedOn,
}) => {
  const isDesktop = useMediaQuery('(min-width: 1200px)')

  return (
    <Box mt={4}>
      {awaitingResponseLeads.length === 0 ? (
        <EmptyStudents
          title="Leads"
          caption="No leads awaiting response."
          IconComp={() => <PermContactCalendarOutlinedIcon fontSize="large" />}
          removeButton
        />
      ) : (
        <EnhancedTable
          rows={awaitingResponseLeads.map(lead => (
            <LeadTableItem
              lead={lead}
              key={lead.id}
              contactMethodOptions={contactMethodOptions}
              setUnviewedLeadCount={setUnviewedLeadCount}
              refetch={refetch}
              showRespondButton
              showRelativeTime
            />
          ))}
          initialOrderBy="submitted"
          initialOrder="desc"
          columns={[
            {
              id: 'name',
              label: 'Name',
              align: 'left',
              width: isDesktop ? '20%' : '50%',
              mobile: true,
              sortable: true,
              sortComparator: sortByFullName,
            },
            {
              id: 'submitted',
              label: 'Submitted',
              align: 'left',
              width: '20%',
              mobile: false,
              sortable: true,
              sortComparator: sortByCreatedOn,
            },
            {
              id: 'interest',
              label: 'Interest',
              align: 'left',
              width: '20%',
              mobile: false,
              sortable: false,
            },
            {
              id: 'actions',
              label: '',
              align: 'right',
              width: isDesktop ? '40%' : '50%',
              mobile: true,
              sortable: false,
            },
          ]}
          label="Awaiting Response"
          numberOfRows={25}
          emptyState={() => null}
        />
      )}
    </Box>
  )
}

export default NewLeads
